import React, { useState } from "react";

const HamburgerButton: React.FC<any> = ({ onClick, isOpenState }) => {
  return (
    <button
      className="flex justify-center items-center w-11 h-11 bg-transparent border-none cursor-pointer p-0 focus:outline-none absolute top-4 right-6 z-60"
      onClick={onClick}
    >
      <div className="relative w-8 h-6">
        {/* The key is to position the lines absolutely so they all center perfectly when forming the X */}
        <span
          className={`absolute top-0 left-0 block h-1 w-full bg-gray-800 transition-all duration-300 ease-in-out ${
            isOpenState ? "top-2.5 transform rotate-45 !bg-blue-800" : ""
          }`}
        ></span>
        <span
          className={`absolute top-[10px] left-0 block h-1 w-full bg-gray-800 transition-all duration-300 ease-in-out ${
            isOpenState ? "opacity-0" : ""
          }`}
        ></span>
        <span
          className={`absolute top-[20px] left-0 block h-1 w-full bg-gray-800 transition-all duration-300 ease-in-out ${
            isOpenState ? "!top-[10px] transform -rotate-45 !bg-blue-800" : ""
          }`}
        ></span>
      </div>
    </button>
  );
};

export default HamburgerButton;
